export const LocalStorageKeys = {
  HighScore: 'highScore',
  Stats: 'stats',
  Theme: 'theme',
}; 